import React, { Component } from 'react';
import { DKLabel, DKIcon, showToast, TOAST_TYPE, DKButton } from 'deskera-ui-library';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import EmployeeListService from '../../services/EmployeeListService';
import FormatCurrencyService from '../../services/FormatCurrencyService';
import PayStubList from '../payroll/PayStubList';
import ic_file_green from "../../assets/FilesIcons/file_green.svg";
import { isMobileWebView } from '../../utility/ViewportSizeUtils';

import { saveAs } from 'file-saver';
import ReportService from '../../services/ReportService';
import { isUSCompliance } from '../../managers/common/CommonUtil';
import RouteManager, { PAGE_ROUTES } from '../../managers/RouteManager';
import Utility from '../../utility/Utility';
import { FORMAT } from '../../constants/Constant';
import MaskInputUtil from '../../SharedComponents/MaskInput/MaskInputUtil';
import PermissionUtils, { ACTION, MODULE } from '../user-permissions/PermissionUtils';
import { getMasked } from '../configs/config';
export default class ContractorView extends Component {
    paystubsData;
    employeeDetails;
    isUSCompliance;

    constructor(props) {
        super(props)
        RouteManager.setPresenter({ props: props });
        const query = props.location && props.location.search ? new URLSearchParams(props.location.search) : "";
        let userId = query && query.get("id") ? query.get("id") : "";
        this.state = {
            userId: props.userId ?? userId,
            fullName: '',
            contractorType: '',
            wagesType: '',
            compensation: '',
            lastPayDate: '',
            mask: MaskInputUtil.MASK_STATE
        }

        this.maskUnmaskObservable = ((PermissionUtils.hasAccess(MODULE.SALARY, [ACTION.VIEW, ACTION.EDIT]) || this.state.userId == TenantService.get(TENANT.USER_ID))) ? MaskInputUtil.subscripeToMaskUnmaskObservable((mask) => {
            this.setState({
                mask: mask
            });
        }) : null;

        const isAdmin = TenantService.get(TENANT.IS_ADMIN);
        this.isUSCompliance = isUSCompliance()
        this.getContractorDetail(userId)
    }
    componentWillUnmount() {
        if(this.maskUnmaskObservable) {
            MaskInputUtil.unsubscribe(this.maskUnmaskObservable);
        }
    }
    getContractorDetail(userId) {
        const config = {
            ...EmployeeListService.apiConfig,
            getComponents: true,
            getCompliance: true,
            getBenefits: true,
            customFieldModule: "",
        };
        EmployeeListService.apiConfig = config;
        EmployeeListService.getEmployeeDetails(userId).then(res => {
            if (res && res.user) {
                this.employeeDetails = res.user
                this.setState({
                    fullName: `${(res.user.firstName) ? res.user.firstName : ''} ${(res.user.lastName) ? res.user.lastName : ''}`,
                    contractorType: res.user.contractorType,
                    wagesType: this.getWagesType(res.user.compensationPeriod),
                    compensation: res.user.compensation
                })
            }
        },
            (error => {
                console.log(error);
            }));

    }
    getWagesType(compensationPeriod) {
        if (compensationPeriod === 'hourly') {
            return 'Hourly Wages';
        } else {
            return 'Fixed Amount';
        }
    }
    getLastPayDate(paystubs) {
        if (paystubs[0] && paystubs[0]['workPeriod'] && paystubs[0]['workPeriod']['to']) {
            return Utility.formatDate(paystubs[0]['workPeriod']['to'], FORMAT.MMDDYYYY_2)
        } else {
            return null;
        }
    }
    getCard() {
        return (
            <div className="parent-width">
                <div className="bg-white p-xl border-radius-m border-m ">
                    <DKLabel
                        className=" fw-m fs-m "
                        text={this.state.fullName} />
                    <DKLabel
                        className="to-lower-case"
                        text={this.state.contractorType} />
                    <div className="row pt-xl">
                        <div className="">
                            <DKLabel
                                className=""
                                text="Wages Type" />
                            <DKLabel
                                className="fw-m"
                                text={this.state.wagesType} />
                        </div>
                        <div className="pl-xxl">
                            <DKLabel
                                className=""
                                text="Amount" />
                            <DKLabel
                                className="fw-m"
                                text={getMasked(this.state.mask, this.state.compensation, null, this.state.userId)} />
                        </div>
                        {this.state.lastPayDate && <div className="pl-xxl">
                            <DKLabel
                                className=""
                                text="Last Pay Date" />
                            <DKLabel
                                className="fw-m"
                                text={this.state.lastPayDate} />
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
    loadPaystub(data) {
        this.paystubsData = data;

        const paystubs = data?.paystubs ? data.paystubs : [];
        this.setState({
            lastPayDate: this.getLastPayDate(paystubs)
        })
    }

    seeAllPaystub() {
        RouteManager.navigateToPage(
            PAGE_ROUTES.PAYSTUB_LIST,
            `id=${this.employeeDetails.userId}&isContractor=${true}`
        );
    }

    getPaystubList() {
        return (
            <div className={`column bg-white  pt-l border-radius-m border-m p-h-xl pb-xl parent-height parent-width mt-l ${this.isUSCompliance ? "web-width-50":"parent-width" }`}>
                <div className="row parent-width">
                    {(this.paystubsData && this.paystubsData['filterResponse'] && this.paystubsData['filterResponse'].totalCount > 5) &&
                        <div className="row-reverse" style={{ marginBottom: "-34px", zIndex: 5 }}>
                            <DKButton
                                title="See All"
                                className="bg-white fw-b fs-l "
                                onClick={() => {
                                    this.seeAllPaystub();
                                }}
                            />
                        </div>
                    }
                </div>
                <div className="parent-width" style={{ overflowX: "hidden",minHeight:"230px", overflowY: "hidden" }}>
                    {this.employeeDetails && <PayStubList id={this.employeeDetails.userId} recent={true} isContractor={true} payStubData={(data)=>this.loadPaystub(data)} mask={this.state.mask}/>}
                </div>
            </div>
        )
    }
    downloadForm(formType) {
        let users = [this.employeeDetails.userId]
        ReportService.downloadForm(users,formType).then(
            (response) => {
                let fileName = `${formType}_${this.employeeDetails.employeeId}_${this.employeeDetails.firstName}_${this.employeeDetails.lastName}`
                saveAs(response,fileName);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        )
    }
    getFormCard() {
        return (
            <div className={`column parent-width bg-white p-xl border-radius-m border-m parent-height web-width-50 mt-l ${!isMobileWebView() ? " ml-l ":""} `} >
                <DKLabel
                    className="  fw-m fs-l"
                    text="Forms" />
                <div className="row p-v-xxl p-h-xl bg-gray1 mt-l">
                    <DKLabel text="W9 Form for Contractors" />
                    <DKIcon
                        className="ml-auto cursor-pointer"
                        onClick={()=>this.downloadForm('W9')}
                        src={ic_file_green} />
                </div>
                <div className="row p-v-xxl p-h-xl bg-gray1 mt-l">
                    <DKLabel text="1099 Misc" />
                    <DKIcon
                        className="ml-auto cursor-pointer"
                        onClick={()=>this.downloadForm('form-1099-misc')}
                        src={ic_file_green} />
                </div>
            </div>
        )
    }
    getPaystubAndForm() {
        return (
            <div className="row row-responsive" style={{
                alignItems: "inherit"
            }}>
                {!isMobileWebView() && this.getPaystubList()}
                {this.isUSCompliance && this.getFormCard()}
            </div>
        )
    }
    render() {
        return (
            <>
                {this.getCard()}
                {this.getPaystubAndForm()}
            </>
        )
    }
}
